import React, { useEffect, useRef } from "react";
import { Formik, Form } from "formik";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import { useDispatch } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { ModalBody } from "reactstrap";
import { updateProfile } from "../../../../redux/profile/action";
import * as Yup from "yup";
import { descriptionvalidation } from "../../../Common/commonvalidation";

const addressValidationSchema = Yup.object().shape({
  address: descriptionvalidation,
});

const ProfileModelAddressDetails = ({
  formData,
  setFormData,
  setModelAddress,
  edittype,
}) => {
  const formikRef = useRef(null);

  const initialValues = {
    address: formData?.address || "",
  };
  const dispatch = useDispatch();

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const handleSubmit = (values) => {
    const data = {
      type: "address",
      address: values.address,
    };
    if (edittype == 1) {
      dispatch(updateProfile(data));
      setModelAddress(false);
    } else {
      setFormData({
        ...formData,
        address: values.address,
      });
      setModelAddress(false);
    }
  };

  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  return (
    <>
      <button
        onClick={() => setModelAddress((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <div>
          <div>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              innerRef={formikRef}
              validationSchema={addressValidationSchema}
              enableReinitialize
            >
              {() => (
                <Form>
                  <FieldInput
                    title="Address"
                    name="address"
                    placeholder="Enter your address"
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </ModalBody>
      <div className="modal-footer mt-3">
        <button className="btn" onClick={() => handleNextClick()}>
          Save
        </button>
      </div>
    </>
  );
};

export default ProfileModelAddressDetails;
